// Small REST adapter preserving the existing screen data interfaces.
// Authorization, ownership and availability are enforced by the server.
export const db = {};
export async function request(path, method = 'GET', body) {
  const response = await fetch('/api' + path, {method, credentials: 'include',
    headers: body === undefined ? {} : {'Content-Type': 'application/json'},
    body: body === undefined ? undefined : JSON.stringify(body)});
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.message || 'The request could not be completed.');
    error.status = response.status;
    window.dispatchEvent(new CustomEvent('rental-error', {detail: error.message}));
    throw error;
  }
  return data;
}
export const collection = (_, name) => ({name, filters: []});
export const doc = (_, name, id) => ({name, id});
export const where = (field, operator, value) => ({field, operator, value});
export const orderBy = (field, direction) => ({field, direction});
export const query = (ref, ...filters) => ({...ref, filters});
export const serverTimestamp = () => new Date().toISOString();
const wrapped = row => ({id: row.id, data: () => row, exists: () => true});
export async function getDocs(ref) {
  let rows = await request('/records/' + ref.name);
  for (const filter of ref.filters || []) {
    if (filter.operator) rows = rows.filter(row => row[filter.field] === filter.value);
    else rows.sort((a, b) => String(a[filter.field]).localeCompare(String(b[filter.field])) * (filter.direction === 'desc' ? -1 : 1));
  }
  return {docs: rows.map(wrapped)};
}
export async function getDoc(ref) {
  const response = await fetch('/api/records/' + ref.name + '/' + encodeURIComponent(ref.id), {credentials: 'include'});
  if (response.status === 404) return {exists: () => false};
  if (!response.ok) throw new Error('Unable to load record');
  return wrapped(await response.json());
}
export function onSnapshot(ref, callback) {
  let active = true, busy = false;
  const refresh = async () => {
    if (busy) return;
    busy = true;
    try { const snapshot = await getDocs(ref); if (active) callback(snapshot); }
    catch (_) {} finally { busy = false; }
  };
  refresh();
  const timer = setInterval(refresh, 15000);
  window.addEventListener('rental-refresh', refresh);
  return () => {active = false; clearInterval(timer); window.removeEventListener('rental-refresh', refresh);};
}
async function write(ref, method, data) {
  const result = await request('/records/' + ref.name + (ref.id ? '/' + encodeURIComponent(ref.id) : ''), method, data);
  window.dispatchEvent(new Event('rental-refresh'));
  return result;
}
export const addDoc = (ref, data) => write(ref, 'POST', data);
export const updateDoc = (ref, data) => write(ref, 'PATCH', data);
export const setDoc = updateDoc;
export const deleteDoc = ref => write(ref, 'DELETE', {});
